import { getServiceFrontendUrl, type ServiceName } from '@airclou/utils';

/**
 * Maps an app row's `slug` (from the entitlements `apps` table) to the shared
 * service registry in `@airclou/utils`, which owns the real URLs per environment.
 * Keep the URLs there, not here — this map is only the slug translation.
 */
const SLUG_TO_SERVICE: Record<string, ServiceName> = {
  dashboard: 'dashboard',
  playbook: 'playbook',
  helpdesk: 'helpdesk',
  forms: 'formBuilder',
  conductor: 'conductor',
};

/** URL to open an app, or undefined when the slug has no known frontend. */
export function getAppUrl(slug: string): string | undefined {
  const service = SLUG_TO_SERVICE[slug];
  return service ? getServiceFrontendUrl(service) : undefined;
}
